import { FunctionComponent, useState } from "react";
import { openConsentSettings, saveConsent } from "./consentStore";
import { consentTexts } from "./texts";
import { useConsent } from "./useConsent";
import "./consent.css";

type MapConsentGateProps = {
  language?: string | null;
  height?: number;
};

// Renders the Google map only with consent for external media. Without it,
// a placeholder explains Google Maps; "Load map" first shows what the visitor
// consents to and saves the consent only after "Allow and load map".
export const MapConsentGate: FunctionComponent<MapConsentGateProps> = ({
  language,
  height = 300,
  children,
}) => {
  const { externalMediaAllowed } = useConsent();
  const [confirming, setConfirming] = useState(false);
  const t = consentTexts(language);

  if (externalMediaAllowed) return <>{children}</>;

  return (
    <div
      className="swt-map-placeholder com-font"
      style={{ minHeight: height }}
      data-testid="map-placeholder"
    >
      {confirming ? (
        <div
          role="alertdialog"
          aria-labelledby="swt-map-confirm-title"
          aria-describedby="swt-map-confirm-text"
          className="swt-map-confirm"
        >
          <strong id="swt-map-confirm-title">{t.mapConfirmTitle}</strong>
          <p id="swt-map-confirm-text">{t.mapConfirmText}</p>
          <div className="swt-consent__buttons">
            <button
              type="button"
              className="btn btn-sm swt-consent__btn"
              onClick={() => saveConsent({ externalMedia: true })}
            >
              {t.mapConfirmAccept}
            </button>
            <button
              type="button"
              className="btn btn-sm swt-consent__btn--outline"
              onClick={() => setConfirming(false)}
            >
              {t.mapConfirmCancel}
            </button>
          </div>
          <button
            type="button"
            className="swt-consent__details-toggle"
            onClick={() => {
              setConfirming(false);
              openConsentSettings();
            }}
          >
            {t.mapConfirmSettings}
          </button>
        </div>
      ) : (
        <>
          <p>{t.mapPlaceholder}</p>
          <button
            type="button"
            className="btn btn-sm swt-consent__btn"
            onClick={() => setConfirming(true)}
          >
            {t.mapLoad}
          </button>
        </>
      )}
    </div>
  );
};
